export type ErrCode =
  HttpErrCode
  | ParamErrCode
  | DBErrCode
  | SystemErrCode
  | UploadErrCode
  | PutNetErrCode
  | DeleteNetErrCode;

export enum ParamErrCode {
  COMMON = 'E0001',
  PARAM = 'P0000',
  PASSWORD = 'P0001',
  TYPE = 'P0002',
  EMPTY = 'P0003',
  CAPTCHA = 'P0004',
  USED = 'P0005',
  DING_DING = 'DD001',
  TENANT = 'C0001',
}

export enum DBErrCode {
  DB = 'D0000',
  ADD = 'D0001',
  REMOVE = 'D0002',
  UPDATE = 'D0003',
  FIND = 'D0004',
  NOT_EXIST = 'D0005',
  LOCKED = 'D0006',
  NOT_CORRECT = 'D0007',
}

export enum SystemErrCode {
  SYSTEM = 'S0000',
  CONFIG = 'S0001',
  NO_PERMISSION = 'S0002',
  CONFLICT = 'S0003',
  PARSE = 'S0004',
  FILE_NOT_FOUND = 'S0005',
  CLASS_NOT_FOUND = 'S0006',
  METHOD_NOT_FOUND = 'S0007',
}

export enum HttpErrCode {
  NOT_MODIFIED = 304,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  PROXY_AUTHENTICATION_REQUIRED = 407,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  GONE = 410,
  LENGTH_REQUIRED = 411,
  PRECONDITION_FAILED = 412,
  PAYLOAD_TOO_LARGE = 413,
  URI_TOO_LONG = 414,
  UNSUPPORTED_MEDIA_TYPE = 415,
  ENHANCE_YOUR_CLAM = 420,
  INTERNAL_SERVER = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505
}

export enum UploadErrCode {
  UPLOAD_ERROR = 'U0001',
  VIDEO_OVER_SIZE = 'U0002'
}

export enum PutNetErrCode {
  PUT_NET_ERROR = 'D0003'
}

export enum DeleteNetErrCode {
  DELETE_NET_ERROR = 'D0001'
}
